import React, { ReactNode, useEffect, useState, useContext } from 'react';

import MUIPortal from '@mui/material/Portal';

import { useIsInsideContainer } from '../hooks';

import { PortalContext } from './PortalContext';

interface PortalProps {
  children: ReactNode | ReactNode[];
}

export const Portal = ({ children }: PortalProps) => {
  const isInsideContainer = useIsInsideContainer();
  const portalContext = useContext(PortalContext);
  const [container, setContainer] = useState<Element | null>(null);

  useEffect(() => {
    if (!isInsideContainer) return;

    const portalId = portalContext?.portalId;
    const widgetContainerId = portalContext?.widgetContainerId;

    if (!portalId || !widgetContainerId) return;

    const shadowRootWrapper = document.getElementById(widgetContainerId);
    const root = shadowRootWrapper?.shadowRoot;
    const portal = root?.getElementById(`portal-container-${portalId}`);

    if (portal) {
      setContainer(portal);
    }
  }, [
    isInsideContainer,
    portalContext?.portalId,
    portalContext?.widgetContainerId,
  ]);

  return (
    <MUIPortal container={isInsideContainer ? container : undefined}>
      {children}
    </MUIPortal>
  );
};
